export default __webpack_public_path__ + "03a547b2c4840a90c8cae3d5381750d1.png";